var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    viewBox: "0 -960 960 960",
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M180.109-102.804q-30.746 0-54.025-23.28-23.28-23.279-23.28-54.025v-599.782q0-30.845 23.28-54.194 23.279-23.35 54.025-23.35h599.782q30.845 0 54.194 23.35 23.35 23.349 23.35 54.194v599.782q0 30.746-23.35 54.025-23.349 23.28-54.194 23.28H180.109Zm0-77.305h599.782V-312.87H640.37q-28.283 40.761-71.066 62.142-42.782 21.38-89.304 21.38-46.522 0-89.304-21.38-42.783-21.381-71.066-62.142H180.109v132.761Zm300.695-118.413q41.073 0 75.678-23.38 34.605-23.381 61.218-60.141h162.191v-397.848H180.109v397.848H342.87q26.804 36.76 61.833 60.141 35.029 23.38 76.101 23.38ZM180.109-180.109H779.891 180.109Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.9ab1089d9db46b67627ca13050d08281.svg";
export { ForwardRef as ReactComponent };